import { Button, Text } from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import styled from 'styled-components'

export const CustomPill = styled(Button)`
  border-radius: 9999px !important;
  padding: 6px 10px;
  cursor: pointer;
  text-align: center;
  transition: 0.5s;
  margin: 2.5px 0px;
  width: 100px;
  height: auto !important;
  font-weight: 500 !important;
  font-size: 15px !important;
  overflow: hidden;

  @media (max-width: 473px) {
    font-size: 12.5px !important;
  }

  @media (max-width: 380px) {
    font-size: 12px !important;
  }

  :hover {
    background: ${COLORS.gold_hover};
  }
`

export const DeleteBtn = styled(Button)`
  border-radius: 9999px !important;
  padding: 5px;
  cursor: pointer;
  transition: 0.5s;
  width: 70px;
  height: auto !important;
  font-weight: 500 !important;
  font-size: 15px !important;

  @media (max-width: 473px) {
    font-size: 13.5px !important;
  }

  @media (max-width: 380px) {
    font-size: 13px !important;
  }

  :hover {
    background: ${COLORS.gold_hover};
  }
`

export const DeletePopupBtn = styled(Button)`
  border-radius: 9999px !important;
  padding: 7.5px;
  cursor: pointer;
  transition: 0.5s;
  width: 80px;
  height: 35px !important;
  font-weight: 500 !important;
  font-size: 17px !important;

  @media (max-width: 473px) {
    font-size: 12.5px !important;
    width: 60px !important;
  }

  @media (max-width: 380px) {
    font-size: 12px !important;
    width: 50px !important;
  }

  :hover {
    background: ${COLORS.gold_hover};
  }
`

export const DeletePopupText = styled(Text)`
  color: rgb(253, 246, 243);
  font-size: 15px !important;

  @media (max-width: 473px) {
    font-size: 13.5px !important;
  }

  @media (max-width: 380px) {
    font-size: 13px !important;
  }
`
